import { buildTrioDeck } from '../data/trioDeck';

const TRIO_DEAL_RULES = {
    3: { handCards: 9, tableCards: 9 },
    4: { handCards: 7, tableCards: 8 },
    5: { handCards: 6, tableCards: 6 },
    6: { handCards: 5, tableCards: 6 },
};

export const buildInitialTrioGameState = (players, targetTrios) => {
    const deck = buildTrioDeck();
    const playerCount = Array.isArray(players) ? players.length : 0;
    const rule = TRIO_DEAL_RULES[playerCount];

    const handCards = rule?.handCards ?? Math.floor(deck.length / Math.max(playerCount, 1));
    const tableCards = rule?.tableCards ?? Math.max(deck.length - (handCards * Math.max(playerCount, 0)), 0);

    const hands = players.map((name, index) => {
        const start = index * handCards;
        const end = start + handCards;
        const hand = deck.slice(start, end).sort((left, right) => left - right);
        return { name, cards: hand };
    });

    const tableStart = playerCount * handCards;
    const middleCards = deck.slice(tableStart, tableStart + tableCards);
    const scores = players.reduce((result, player) => ({ ...result, [player]: 0 }), {});
    const collectedTrios = players.reduce((result, player) => ({ ...result, [player]: [] }), {});
    return { hands, tableCards: middleCards, scores, collectedTrios, targetTrios };
};

export const cloneTrioGameState = (snapshot) => {
    if (!snapshot || typeof snapshot !== 'object') return null;
    return JSON.parse(JSON.stringify(snapshot));
};
